import { render, staticRenderFns } from "./NoCommunityAffiliation.vue?vue&type=template&id=226b1ec5&scoped=true&"
import script from "./NoCommunityAffiliation.vue?vue&type=script&lang=js&"
export * from "./NoCommunityAffiliation.vue?vue&type=script&lang=js&"
import style0 from "./NoCommunityAffiliation.vue?vue&type=style&index=0&id=226b1ec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b1ec5",
  null
  
)

export default component.exports